// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Trasa_wrapper__2Ekay","left":"Trasa_left__3Fe4v","title":"Trasa_title__uA-M_","p":"Trasa_p__uxfZs","right":"Trasa_right__kTjQF","chinaMap":"Trasa_chinaMap__3LkZK"};